import datapoints from './datapoints';
import markItemsAsPinnedService from '../services/markItemsAsPinnedService';
import { setRowOperation } from 'owa-mail-list-actions';
import { filterConversationRowsByRestriction, getIsTableConversationRelationPinned, getTableConversationRelation, } from 'owa-mail-list-store';
import { actionNames } from 'owa-mail-store-actions';
import * as undoActions from 'owa-mail-undo';
import { action } from 'satcheljs/lib/legacy';
import { raiseAction } from 'satcheljs/lib/legacy/stitch';
import { getRowIdsFromRowKeys, } from 'owa-mail-list-store';
function getItemIdsToUpdate(rowKeys, tableViewId, shouldMarkAsPinned) {
    var itemIdsToUpdate = {};
    for (var i = 0; i < rowKeys.length; i++) {
        var tableConversationRelation = getTableConversationRelation(rowKeys[i], tableViewId);
        if (shouldMarkAsPinned) {
            // If pinning, pin the last item in each conversation. The last delivered item is first in the list of ItemIds
            var itemId = tableConversationRelation.itemIds[0];
            if (!itemIdsToUpdate[itemId]) {
                itemIdsToUpdate[itemId] = true;
            }
        }
        else {
            // If unpinning, unpin all local items in conversation.
            tableConversationRelation.itemIds.forEach(function (itemId) {
                if (!itemIdsToUpdate[itemId]) {
                    itemIdsToUpdate[itemId] = true;
                }
            });
        }
    }
    return Object.keys(itemIdsToUpdate);
}
function shouldPerformPinUnpinAction(tableConversationRelation, pin) {
    return (tableConversationRelation &&
        getIsTableConversationRelationPinned(tableConversationRelation) != pin);
}
export default action('pinConversations', datapoints.pinConversationsDatapoint)(function pinConversations(conversationRowKeys, tableView, shouldMarkAsPinned, actionSource) {
    undoActions.clearLastUndoableAction();
    var filteredRowKeys = filterConversationRowsByRestriction(conversationRowKeys, tableView.id, shouldPerformPinUnpinAction, shouldMarkAsPinned);
    var conversationIdStrings = getRowIdsFromRowKeys(filteredRowKeys, tableView.id);
    var itemIdsToUpdate = getItemIdsToUpdate(filteredRowKeys, tableView.id, shouldMarkAsPinned);
    if (itemIdsToUpdate.length == 0) {
        // No need to send out the service call
        return Promise.resolve();
    }
    raiseAction(actionNames.MarkConversationsAsPinned)(conversationIdStrings, tableView.id, shouldMarkAsPinned);
    // Treat this pinning operation as a row move operation
    setRowOperation(tableView, 2 /* RowMove */);
    // Make service request
    // Task 658: Reload client state when pin action fails on the server
    markItemsAsPinnedService(itemIdsToUpdate, shouldMarkAsPinned);
    // return the promise to catch the end to end time of pinConversationDatapoint
    return Promise.resolve();
});
//# sourceMappingURL=pinConversations.js.map